<template>

  <div id="training-app" v-if="showApp" :class="{'uk-animation-fade uk-animation-reverse':showApp}">
    <div style="margin-bottom:2vh" class="progress-container">
      <div :style="progressMargin" v-if="hasPassed">
        <div
          v-for="num in this.numFrames"
          :key="num+translateH"
          @click="selectFrame(num)"
          :class="{activeFrame: num === currentFrame}"
          :style="circleshotfix"
          class="circle outline uk-background-primary"
          ></div>
        </div>

      <progress :style="progressbarfix"
                v-if="startedModule && !hasPassed"
                id="js-progressbar"
                class="uk-progress outline uk-animation-scale-up"
                :value="currentFrame"
                :max="numFrames"></progress>
    </div>

      <app-dashboard
        class="uk-animation-fade"
        v-if="showDashboard"
        :nextFrame="nextFrame"
        :frameNum="1"
        :key="rootwindow.width+1"
        :modules="trainingModules"
        @selectModule="loadModule($event)"></app-dashboard>

      <app-frame v-for="(item, index) in loadedModule"
        :key="rootwindow.width+index+2"
        :frameNum="index+2"
        :style="trn"
        :answersArray="useranswers"
        :completionText="completionText"
        :testscore="testScore"
        :fullTest="fullTest"
        v-bind="item"
        :nextFrame="nextFrame"
        :previousFrame="previousFrame"
        :updateAnswer="updateUserAnswer"></app-frame>

  </div>
</template>

<script>

import TrainingDashboard from './components/TrainingDashboard.vue'
import Frame from './components/Frame.vue'
import ax from '../store/apicall.js'
import _ from 'lodash';

export default {
  name: 'app',
      components: {
        appFrame:Frame,
        'app-dashboard':TrainingDashboard
  },
  data () {
    return {
      showApp: true,
      showDashboard: true,
      totalFrames: 0,
      numFrames: 2,
      currentFrame: 1,
      savedProgressFrame:1,
      translateH: 0,
      rootwindow: {
        width: 0,
        height: 0
      },
      training_moduleoverview: [],
      trainingModules: [],
      allModuleFrames: [],
      totalQuestions: 0,
      useranswers: [],
      currentAnswer: 0,
      hasPassed: true,
      completionText: "Fail",
      testScore: 0,
      loadedModule: [{
          event_order: 1,
          event_type: 'html_text',
          html_text: "Welcome to the Check ID Certification",
          id: 1,
          module: 1,
          multiple_choice: null,
          video: null
        }],
      startedModule: false,
      arbitrary: [],
      errors: [],
      fullTest: [],
      current_module_id: 0,
    }
  },
  computed: {
    trn (){
      if(window.innerWidth < 800){
        return `transform: translateX(${ this.translateH }px; width:${ this.rootwindow.width }px; top: 12vh;`
      } else {
        return `transform: translateX(${ this.translateH }px; width:${ this.rootwindow.width }px`
      }
    },
    progressMargin(){
      if(window.innerWidth < 420){
        return `margin-top:2.5vh;`
      } else if(window.innerWidth < 801){
        return `margin-top:-2vh;`
      } else {
        return `margin-top:-6vh;`
      }
    },
    screensizecomp(){
      if(window.innerWidth < 801){
        return `margin-top: 6vh;`
      } else {
        return `margin-top:3vh;`
      }
    },
    progressbarfix(){
      if(window.innerWidth > 801){
        return `margin-top: -2.5vw;`
      }
    },
    circleshotfix(){
      if(window.innerWidth < 420){
        return `margin:5px; padding: 3px;`
      } else if(window.innerWidth < 801){
        return `margin:7px;`
      }
    }
  },
  created() {
    let doc = document.getElementsByTagName('html');
    let tag = doc[0]
    tag.style.overflowY = 'hidden'
    this.getModules()
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  mounted(){
    let topMenu = document.getElementById('top-menu');
    topMenu.style.backgroundColor = 'white';
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
    let topMenu = document.getElementById('top-menu');
    topMenu.style.backgroundColor = 'initial';
    let doc = document.getElementsByTagName('html')
    let tag = doc[0]
    tag.style.overflowY = 'initial'
  },
  methods: {
    createEmptyBody(){
      let base = {"purpose":"","parameters":{"module_id":""}}
      return function(purpose){
        if(purpose === undefined){
          return Object.assign(base)
        }
        return Object.assign({"purpose":String(purpose),"parameters":{"module_id":""}})
      }
    },
    async getModules(){
      try {
        let payload_purpose = this.createEmptyBody()
        let payload = payload_purpose("get_modules")
        let data = await ax.post('/training/', payload);
        this.trainingModules = [...data.data];
        this.checkUserHistory()
        this.getEvents()
      } catch (error) {
        this.errors.push(error)
      }
    },
    checkUserHistory(){
      this.trainingModules = this.trainingModules.reduce((acc, cv) => {
        if(cv.user_history === undefined){
          cv.user_history = {"last_event":{"event_order": 1}}
          acc.push(cv)
        } else {
          acc.push(cv)
        }
        return acc
      }, [])
    },
    async getEvents(){
      try {
        let payload_purpose = this.createEmptyBody()
        let payloads = this.getEventsPayloads()
        let response = await Promise.all(payloads.map(async v => ax.post('/training/', v)));
        // these results in response may not be sorted, add sorting method if more than 1
        let data = response.map(v => v.data)
        this.allModuleFrames.push(data)
      } catch (error) {
        this.errors.push(error)
      }
    },
    getEventsPayloads(){
      let payloads = this.trainingModules.map((v,i) => {
        let newpayload = this.createEmptyBody()
        let payload = newpayload("get_events")
        payload.parameters.module_id = i+1
        return payload
      });
      return payloads
    },
    loadModule(event){
      let mod = this.trainingModules[event.module.id-1]
      this.savedProgressFrame = mod.user_history.last_event.event_order
      this.testScore = mod.user_history.final_grade
      this.current_module_id = event.module.id

      if(mod.user_history.passed){
        this.completionText = "Pass";
        this.hasPassed = true;
      }

      let unsortedModuleFrames = this.allModuleFrames[event.module.id-1][0].slice()
      this.loadedModule = _.sortBy(unsortedModuleFrames, ['event_order'])

      var count = 0;
      this.loadedModule.reduce((acc, cv) => {
        if (cv.event_type === "multiple_choice"){
          let test_question_full = {...cv.multiple_choice}
          test_question_full['incorrect'] = false
          this.fullTest.push(test_question_full)
          cv.multiple_choice.question_number = count
          count+=1
        }
        acc.push(cv)
        return acc
      }, []);

      this.totalQuestions = count
      this.useranswers = new Array(count).fill('none')
      this.numFrames = this.loadedModule.length+1

      if(this.savedProgressFrame > 1){
        this.selectFrame(this.savedProgressFrame+2)
      } else{
        this.nextFrame(this.currentFrame+1)
      }
      this.startedModule = true;
      this.showDashboard = false;
    },
    handleResize() {
      this.rootwindow.width = window.innerWidth ;
      this.rootwindow.height = window.innerHeight;
      this.translateH = ((this.currentFrame-1)*-1)*window.innerWidth;
    },
    selectFrame(frame){
      // console.log(frame)
      if(frame === 1){
        this.showDashboard = true;
      } else {
        this.showDashboard = false;
      }
      let distance = this.currentFrame-frame
      this.currentFrame = frame
      this.translateH = window.innerWidth*distance+this.translateH
    },
    scrollTop(id){
      let training_app_element = document.getElementById(String(id))
      training_app_element.scrollTop = 0
    },
    moveFrameLeft(event){
      this.currentFrame = event;
      this.translateH = this.translateH-window.innerWidth
    },
    checkPrevent(event){
      switch(event){
        case "prevent":
          return true;
        case "dashboard":
          console.log("dashboard");
          this.dashboardReset()
          return true;
        case "dashboard-reset":
          let resetFinished = this.resetProgress()
          this.arbitrary.push(resetFinished)
          this.getModules()
          this.dashboardReset()
          return true
        default:
          return false;
      }
    },
    async nextFrame(event){
      this.scrollTop('training-app')
      // event === 1 ? this.showDashboard = true: this.showDashboard = false;
      if(event === 1 || event > this.numFrames){
        setTimeout(() => {
          this.showDashboard = true;
        }, 1000)
      }

      if(event > this.numFrames){
        // this.numFrames is +1 of the modules length, you shouldn't be able to translateX past to blank space
        this.translateH = 0
        this.currentFrame = 1
        this.startedModule = false;
      } else {
        if(!this.checkPrevent(event)){
          this.checkUpdateProgress(event)
          this.moveFrameLeft(event)
        }
      }

      let VideoFrameNums = [3,7,11,16]
      if(VideoFrameNums.indexOf(event) !== -1){
        let id = "videoPlayer"+String(event);
        let videoPlayer = document.getElementById(String(id))
        var resolved = videoPlayer.play()
      }

    },
    checkUpdateProgress(event){

      if(event >= 1 && event > this.currentFrame){
        this.savedProgressFrame = event;
        this.savedFrameId = this.allModuleFrames[0][0][event-2].id
        this.updateUserProgress()
        this.currentAnswer = 0
      }
    },
    async updateUserProgress(){
      try {
        let event_order_offsetfix = this.savedProgressFrame-2
        if(event_order_offsetfix < 1){
          event_order_offsetfix = 1
        }
        let newpayload = this.createEmptyBody()
        let payload = newpayload("update_user_progress")
        payload.parameters.module_id = this.current_module_id
        payload.parameters.event_order = event_order_offsetfix
        payload.parameters.selection = Number(this.currentAnswer)

        if(payload["parameters"].hasOwnProperty("selection") && this.currentAnswer === 0){
          payload["parameters"]["selection"] = "";
        }
        // console.log(body)
        let data = await ax.post('/training/', payload)
        if(data.data.final_grade > 0){
          this.testScore= data.data.final_grade
          if(data.data.passed === true){
            this.hasPassed = true
            this.completionText = "Pass"
          } else {
            this.completionText = "Fail"
          }
        }
        this.arbitrary.push(data)
      } catch (error) {
        this.errors.push(error)
      }


    },
    dashboardReset(){
      this.showApp = false;
      setTimeout(() => {
          this.translateH = 0;
          this.currentFrame = 1;
          this.startedModule = false;
      }, 500);

      setTimeout(() => {
          this.showApp = true;
      }, 1000);
    },
    async resetProgress(){
      let body = {
        "purpose": "update_user_progress",
        "parameters": {
          "module_id": 1,
          "event_order":1,
          "reset": 1
          }
        }
      return await ax.post('/training/', body).then(data => {
        // console.log(data)
        this.arbitrary.push(data)
      }).catch(err => {
        this.errors.push(err)
      });
    },
    previousFrame(event){
      if(event >= 1){
        this.currentFrame = event
        this.translateH = this.translateH+window.innerWidth
      }
    },
    updateUserAnswer(index, answer){
      this.useranswers.splice(index, 1, answer)
      this.currentAnswer = answer
      // console.log(this.useranswers)
    },
  }
}
</script>

<style>

.navigate-frame-btn {
  min-height: 7vh;
  font-size: 1.6em !important;
}

#training-app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 9vw 5vw 3vw 5vw;
  /* padding-top: ; */
  transition: all 333ms ease-in;
  animation: fadein 1200ms ease;
  position: absolute;
  width: 90vw;
  height: 82%;
  top: 3vh;
  background-color: #ffffff;
  overflow-x: hidden;
}

.frame-max {
  position: absolute;
  /*background-color: #ffffff;*/
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  top: 16vh;
  padding: 0 5vw;
  text-align: left;
  transition: all 800ms ease-in-out;
}

.outline {
  border: 1px solid #575757;
  margin-bottom: 0px;
}

.circle {
  display: inline-block;
  margin: 10px;
  padding: 5px;
  border-radius: 50%;
  width: .4vw;
  height: .4vw;
  background-color: #9a9a9a;
  opacity: 0.4;
}

.activeFrame {
  opacity: 1;
  background-color: #1e87f0;
}

.btn-extra-large-text {
  font-size: 1.7em;
}

@keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
